import { useState, useEffect } from 'react';
import { Shield, Award, Wrench, FileCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Hero = ({ setShowForm }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch(`${API}/site-content`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.hero) setContent(data.hero); })
      .catch(() => {});
  }, []);

  const badge = content?.badge_text || 'Limited Time Offer - Save Up To $7,089';
  const headline = content?.headline || 'Licensed and Insured Installation with 10 Year Factory Warranty & All Permits Included!';
  const subtitle = content?.subtitle || 'Premium Goodman Heat Pump Systems Installed with 10 Year Factory Warranty';
  const promo1 = content?.promo_line1 || 'NO MONEY DOWN & NO PAYMENTS FOR 6 MONTHS!*';
  const promo2 = content?.promo_line2 || '3 Ton Unit, $98 per month with a 450+ credit score, you will be approved!';

  return (
    <section 
      className="bg-gradient-to-br from-emerald-800 via-emerald-700 to-emerald-600 flex items-center relative overflow-hidden py-10 sm:py-12 lg:py-16"
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 w-full relative z-10">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-4 sm:space-y-6">
            <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-xs sm:text-sm font-semibold px-3 sm:px-4 py-1.5 sm:py-2 rounded-full">
              {badge}
            </span>
            
            <h1 
              className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight"
              data-testid="hero-title"
            >
              {headline}
            </h1>
            
            <p 
              className="text-sm sm:text-lg text-white/90 max-w-xl"
              data-testid="hero-subtitle"
            >
              {subtitle.includes('10 Year') ? (
                <>
                  {subtitle.split('10 Year')[0]}<strong className="text-white">10 Year{subtitle.split('10 Year').slice(1).join('10 Year')}</strong>
                </>
              ) : subtitle}
            </p>

            {/* SEO-rich subtext for near me queries */}
            <p className="text-xs text-white/70 max-w-xl">
              Professional AC installation near me in Central Florida. New AC unit installation, air conditioner installation, and home AC installation services across 11 counties.
            </p>

            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-2 sm:gap-3">
              <div className="flex items-center gap-1.5 sm:gap-2 bg-white/10 backdrop-blur-sm px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full">
                <Shield className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-200" />
                <span className="text-xs sm:text-sm text-white font-medium">10 Year Factory Warranty</span>
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 bg-white/10 backdrop-blur-sm px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full" data-testid="hero-pill-permitting">
                <FileCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-200" />
                <span className="text-xs sm:text-sm text-white font-medium">Permitting Included</span>
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 bg-white/10 backdrop-blur-sm px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full">
                <Award className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-200" />
                <span className="text-xs sm:text-sm text-white font-medium">Licensed & Insured</span>
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 bg-white/10 backdrop-blur-sm px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full">
                <Wrench className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-200" />
                <span className="text-xs sm:text-sm text-white font-medium">Expert Installation</span>
              </div>
            </div>

            {/* Financing Promo */}
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-5 border border-white/20">
              <p className="text-xl sm:text-3xl font-black text-yellow-300 tracking-tight leading-tight">
                {promo1}<span className="text-yellow-400">*</span>
              </p>
              <p className="text-sm sm:text-xl font-bold text-yellow-300 mt-1.5 sm:mt-2">
                {promo2}
              </p>
            </div>
          </div>

          {/* Right Side - Promotional Image */}
          <div className="mt-2 lg:mt-0">
            <img 
              src="/hero-banner-permit.webp"
              alt="Goodman Heat Pump A/C Systems - AC Installation Near Me - Sam and Steve with HVAC units, New AC Unit Installation from $98 per month"
              className="w-full h-auto rounded-2xl shadow-2xl max-w-md mx-auto lg:max-w-none"
            />
            <div className="mt-4 flex justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_cooling-converter/artifacts/85z1nrng_resized_600x60.png"
                alt="Special Thank You to our trusted installation partners - Strada Services LIC#CAC043953 and Florida Breeze Air & Heat LIC#CAC-1814113"
                className="max-w-md w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
